

import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError, switchMap, catchError } from "rxjs";
import { Router } from "@angular/router";
import { isJwtExpired, TokenRefreshService, clearLocalStoragePreserving } from "src/@shared/auth";
import { AuthEndpoints } from "src/@shared/shared/enum";

@Injectable({
  providedIn: "root",
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private tokenRefresh: TokenRefreshService, private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.has('Authorization') || request.url.endsWith(AuthEndpoints.Refresh)) {
      return next.handle(request);
    }

    const token = localStorage.getItem("BearerToken");
    return next.handle(this.withBearer(request, token)).pipe(
      catchError((error: unknown) => {
        if (!token || !this.isExpiredTokenResponse(error, token)) {
          return throwError(() => error);
        }
        return this.tokenRefresh.refresh().pipe(
          switchMap((freshToken) => next.handle(this.withBearer(request, freshToken))),
          catchError((refreshError: unknown) => {
            clearLocalStoragePreserving();
            sessionStorage.clear();
            void this.router.navigate(['/login']);
            return throwError(() => refreshError);
          })
        );
      })
    );
  }

  private isExpiredTokenResponse(error: unknown, token: string): boolean {
    return error instanceof HttpErrorResponse
      && error.status === 401
      && (error.headers.get('Token-Expired') === 'true' || isJwtExpired(token));
  }

  private withBearer(request: HttpRequest<unknown>, token: string | null): HttpRequest<unknown> {
    return token ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : request;
  }
}
